import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Get Campaigns (Brand Dashboard)
export async function loadCampaignsApi(agency_id,page_no) {
  try {
    const fd = new FormData();

    fd.append("agency_id", agency_id || "");
    fd.append("page_no", page_no || "0");

    const res = await axios.post(`${apiBaseUrl}campaignapis/get_campaigns`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}


// ✅ Get Campaign Detail
export async function getCampaignDetailApi(campaign_id) {
  try {
    const fd = new FormData();

    fd.append("campaign_id", campaign_id || "");

    const res = await axios.post(`${apiBaseUrl}campaignapis/get_campaign_detail`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}


// ✅ Create / Update Campaign
export async function createCampaignApi(payload) {
  try {
    const fd = new FormData();

    fd.append("campaign_id", payload.campaign_id || "");

    fd.append("campaign_user", payload.campaign_user || "");
    fd.append("campaign_title", payload.campaign_title || "");
    fd.append("campaign_desc", payload.campaign_desc || "");
    fd.append("campaign_type", payload.campaign_type || "");

    fd.append("campaign_start_date", payload.campaign_start_date || "");
    fd.append("campaign_end_date", payload.campaign_end_date || "");

    fd.append("campaign_target_audience", payload.campaign_target_audience || "");
    fd.append("campaign_target_regions", payload.campaign_target_regions || "");

    fd.append("campaign_status", payload.campaign_status || "draft");

    // ⭐ CRITICAL FIELD (matches backend)
    fd.append("campaign_influencers", payload.influencers || "");

    fd.append("by", payload.by || "");

    const res = await axios.post(
      `${apiBaseUrl}campaignapis/create_campaign`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}


// ✅ Update Campaign Status
export async function updateCampaignStatusApi(campaign_id, campaign_status) {
  try {
    const fd = new FormData();

    fd.append("campaign_id", campaign_id);
    fd.append("campaign_status", campaign_status);

    const res = await axios.post(`${apiBaseUrl}campaignapis/update_campaign_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}

export async function delCampaignApi(campaign_id) {
  try {
    const fd = new FormData();

    fd.append("campaign_id", campaign_id);

    const res = await axios.post(`${apiBaseUrl}campaignapis/del_campaign`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}
